import { Button, IconTextBox } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { GetFieldType } from "../../utils/helpers";

export const FieldTypeInputTemplate = ({
  fieldType,
  index,
  persistentValue,
  onInputChange,
  onRemoveFieldType,
}) => {
  const { t } = useTranslation(["CustomFieldGroup"], {
    useSuspense: false,
  });

  return (
    <div className="custom-field-input-list px-3 py-2 rounded bg-white shadow-sm mb-2">
      <div className="d-flex justify-content-between align-items-center">
        <div className="col-7 d-flex justify-content-start align-items-center gap-4">
          <i className="fa-regular fa-grip-dots-vertical grip et-black cursor-grab"></i>
          <div className="col-12 d-flex justify-content-start align-items-center gap-2">
            <div>{index + 1}.</div>
            <div className="col-12 d-flex justify-content-between align-items-center">
              <IconTextBox
                name={`CustomFields[${index}].Label`}
                placeholder={t("NameThisField")}
                onChange={(e) => onInputChange(e.target.value)}
                value={persistentValue?.Label ?? ""}
                icon={`${GetFieldType(fieldType)?.icon}`}
                autoFocus
              />
            </div>
          </div>
        </div>
        <div className="remove">
          <Button
            id={"dd_field-type-remove-button"}
            className="btn btn-default w-auto et-darkest-gray"
            onClick={onRemoveFieldType}
            iconCss="fa-regular fa-circle-minus"
          />
        </div>
      </div>
    </div>
  );
};
